import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-credit-card",
  "use": "icon-credit-card-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-credit-card\"><path d=\"M3.333 3.333c-.92 0-1.666.746-1.666 1.667v10c0 .92.746 1.666 1.666 1.666h13.334c.92 0 1.666-.745 1.666-1.666V5c0-.921-.745-1.667-1.666-1.667H3.333zm0 1.667h13.334v1.666H3.333V5zm0 4.166h13.334V15H3.333V9.166z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol